import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import cn from 'classnames';
import Sticky from 'react-sticky-el';

import groupBy from 'lodash.groupby';
import toPairs from 'lodash.topairs';

import { loadCollection } from 'actions/collections';

import ClientHeader from '../Header/ClientHeader';
import BuildingCard from 'components/BuildingCard';
import RealtorCard from 'components/RealtorCard';
import Modal from 'components/Modal';

import Dropdown from 'components/common/Dropdown';
import Menu from 'components/common/Menu';

import Loader from './Loader';
import NoPage from './NoPage';

import styles from './ClientCollection.scss';
import iconMap from 'assets/images/icons/icon-search-map.svg';
import YMap from '../Buildings/YMap';
import { loadData } from '../../actions/objects';
import { withTranslation } from 'react-i18next';
import i18n from '../../i18n';
import { getParams, isSectionAllowed } from '../Building/Main/helper';

const sorts = {
  'district DESC': {
    text: i18n.t('components.clientCollection.district'),
    orderField: 'district',
    orderDirection: 'DESC',
    key: 'districtDesc'
  },
  'costMin ASC': {
    text: i18n.t('components.clientCollection.costMinASC'),
    orderField: 'costMin',
    orderDirection: 'ASC',
    key: 'costAsc'
  },
  'costMin DESC': {
    text: i18n.t('components.clientCollection.costMinDESC'),
    orderField: 'costMin',
    orderDirection: 'DESC',
    key: 'costDesc'
  }
};

const sortKeys = Object.keys(sorts);

const Collection = (props) => {
  const [state, setState] = useState({
    orderField: 'district',
    orderDirection: 'DESC',
    showMap: false
  });

  useEffect(() => {
    const { base64, referal } = props.match.params;
    if (base64) {
      getParams(base64).then(data => props.loadCollection({ referal: data.r }));
    } else {
      props.loadCollection({ referal });
    }

    props.loadData(false, {
      limit: 10,
      orderField: 'date_update',
      orderDirection: 'DESC',
      region: [
        '1',
        '2',
        '3',
        '4',
        '5',
        '6'
      ],
      deadlineEnd: false,
      typeId: 1
    }, true);
  }, []);

  const handleSortClick = (orderField, orderDirection) => {
    setState({
      orderField,
      orderDirection
    });
  };

  const renderCard = (building) => {
    const { base64, referal } = props.match.params;

    const makeUrl = () => {
      if (referal) {
        return `/view/${props.match.params.referal}/building/`;
      }

      return `/ncollection/${base64}/`;
    };

    return ( // image={building.albums.rows && building.albums.rows[0] && building.albums.rows[0].images[0]}
      <BuildingCard
        {...building}
        className={styles.BuildingCard}
        title={props.selection.showInfo === '0' ? null : building.title}
        address={props.selection.showInfo === '0' ? null : building.address}
        url={makeUrl()}
        target="_blank"
        key={building.id}
        collection="true"
        withDetails={isSectionAllowed('nameAddress')}
        showStatus={isSectionAllowed('nameAddress')}
        client
      />
    );
  };

  const handleShowMapClick = () => {
    setState(prevState => ({
      ...prevState,
      showMap: true
    }));
  };

  const handleClose = () => {
    setState(prevState => ({
      ...prevState,
      showMap: false
    }));
  };

  const {
      buildings,
      user,
      dispatch,
      match: { params },
      // count_flats: flatsCount,
      selection: { name, showInfo },
      noPageExist,
      t,
      objects = {} }
     = props;

  const { points } = objects;

  const sortKey = `${state.orderField} ${state.orderDirection}`;

  if (noPageExist) {
    return (
      <ClientHeader params={params}>
        <NoPage />
      </ClientHeader>
    );
  }

  return (
    <ClientHeader params={params}>
      {
          buildings ? (
            <div className={styles.ClientCollectionWrap}>
              <div className={styles.ClientCollection}>
                <div className="ContainerWrap">
                  <div className={styles.Container}>
                    <div className={styles.ClientCollectionLeft}>
                      <div className={styles.ClientCollectionTitle}>
                        {name}
                        <div className={styles.SortBy}>
                          <Dropdown
                            className={cn(styles.Dropdown)}
                            buttonStyle={styles.DropdownButton}
                            textStyle={styles.DropdownText}
                            iconStyle={styles.DropdownIcon}
                            text={sorts[sortKey].text}
                            data-tip={t('components.clientCollection.sort')}
                            data-for="tooltip"
                            topShift
                          >
                            <Menu rightArrow pure>
                              <div className={styles.OrderMenu}>
                                {sortKeys.map((key) => {
                                  const sort = sorts[key];
                                  const { orderField, orderDirection } = sort;
                                  return (
                                    <div
                                      key={key}
                                      className={cn(styles.OrderMenuItem, { [styles.OrderMenuActive]: key === sortKey })}
                                      onClick={handleSortClick.bind(undefined, orderField, orderDirection)}
                                    >
                                      <span>{sort.text}</span>
                                    </div>
                                  );
                                })}
                              </div>
                            </Menu>
                          </Dropdown>
                        </div>
                        {
                          showInfo === '1' && isSectionAllowed('nameAddress') ?
                            <div className={styles.OpenMapBtn} onClick={handleShowMapClick}>
                              <img src={iconMap} alt="" /> {t('components.clientCollection.searchOnMap')}
                            </div> : null
                        }
                      </div>
                      <div className={styles.ClientCollectionList}>
                        {
                          buildings && (
                              state.orderField === 'district' ? (
                                  toPairs(
                                      groupBy(
                                          buildings,
                                          'microregion'
                                      )
                                  ).map(
                                      ([district, array]) => [
                                        isSectionAllowed('nameAddress') ? <p className={styles.CollectionListTitle}>{district}</p> : null,
                                        array.map(renderCard)
                                      ]
                                  )
                              ) : (
                                  buildings.sort(
                                      (b1, b2) => (b1.cost_min - b2.cost_min) * (state.orderDirection === 'ASC' ? 1 : -1)
                                  ).map(
                                      renderCard
                                  )
                              )
                          )
                        }
                      </div>
                    </div>
                    <div className={styles.ClientCollectionRight}>
                      <Sticky
                        className={styles.stickyElNotFixed}
                        stickyClassName={styles.stickyEl}
                        boundaryElement=".ContainerWrap"
                        bottomOffset={80}
                      >
                        { user && <RealtorCard {...user} className={styles.RealtorBlock} /> }
                      </Sticky>
                    </div>
                    {
                      <Modal
                        isOpen={state.showMap}
                        handleClose={handleClose}
                        title={t('components.clientCollection.map')}
                        contentStyle={{
                          width: '80vw',
                          height: '80vh'
                        }}
                      >
                        <YMap
                          className={styles.Map}
                          dispatch={dispatch}
                          data={buildings}
                          infoType="medium"
                          points={points}
                        />
                      </Modal>
                    }
                  </div>
                </div>
              </div>
            </div>
          ) : (
            <Loader className={styles.ClientCollectionLoader} />
          )
        }
    </ClientHeader>
  );
};

const mapStateToProps = ({ collection, objects }) => ({
  ...collection,
  objects
});

const mapDispatchToProps = { loadCollection, loadData };

export default withTranslation()(
  connect(mapStateToProps, mapDispatchToProps)(Collection)
);



// WEBPACK FOOTER //
// ./src/components/ClientCollection/ClientCollection.js